import { Alert, Button, Modal } from "@/ui";

/** Shown right after creating a sales rep or counter — D-04's temp password, in case the welcome message never arrives. */
export function TempPasswordModal({
  open,
  onClose,
  name,
  signInWith,
  tempPassword,
}: {
  open: boolean;
  onClose: () => void;
  name: string;
  /** Their email, or their mobile number when they have no email (D-18). */
  signInWith: string;
  tempPassword: string;
}) {
  return (
    <Modal
      footer={<Button onClick={onClose}>Done</Button>}
      onClose={onClose}
      open={open}
      title="Account created"
      width="sm"
    >
      <div className="flex flex-col gap-3">
        <Alert kind="info">
          Share these with {name} in case the welcome message does not arrive. The temporary
          password expires in 7 days and must be changed at first sign-in.
        </Alert>
        <div className="rounded-md border border-rule bg-surface p-3">
          <p className="text-xs text-muted">Sign in with</p>
          <p className="font-mono text-sm text-ink">{signInWith}</p>
          <p className="mt-2 text-xs text-muted">Temporary password</p>
          <p className="font-mono text-base text-ink">{tempPassword}</p>
        </div>
      </div>
    </Modal>
  );
}
